import { z } from 'zod';
import { isValidPostalCode, normalizePostalCode, isValidHouseNumber, normalizeHouseNumber, cleanText } from '@/lib/address';

export const businessQuoteSchema = z.object({
	is_business: z.literal(true),
	business_name: z.string().min(2, 'Bedrijfsnaam is verplicht'),
	contact_phone: z.string().min(5, 'Telefoonnummer is verplicht'),
	contact_email: z.string().email('Ongeldig e-mailadres'),
	service_category: z.enum(['vrf', 'serverruimte', 'winkel_horeca']).optional(),
	location_street: z.string().min(2, 'Straat is verplicht').transform(cleanText),
	location_house_number: z
		.string()
		.min(1, 'Huisnummer is verplicht')
		.refine(isValidHouseNumber, { message: 'Huisnummer moet met een cijfer beginnen (bijv. 12A)' })
		.transform(normalizeHouseNumber),
	location_postal_code: z
		.string()
		.min(1, 'Postcode is verplicht')
		.refine(isValidPostalCode, { message: 'Ongeldige postcode. Bijv. 1234 AB.' })
		.transform(normalizePostalCode),
	location_city: z.string().min(2, 'Plaats is verplicht').transform(cleanText),
	location_remarks: z.string().optional(),
	privacy_agreed: z
		.boolean()
		.refine((val) => val === true, { message: 'U moet akkoord gaan met de privacyverklaring' }),
	token: z.string().optional(),
});

export type BusinessQuoteFormSchema = z.infer<typeof businessQuoteSchema>;
